module.exports = __webpack_public_path__ + "img/IMPORT.8304e8a2.svg";